import React from 'react';
import { Box, Card, CardContent, ListItemText } from '@mui/material';
import { ImagenDashboard } from 'Images/index';
import useTranslation from 'Hooks/useTranslation';
import { CardContentStyle, CardContentTop, ListItemStyle, CardContentBack } from './style';

export default function InteractiveList({ name = '' }) {
  const firstName = name.trim().split(' ')[0];
  const { t2 } = useTranslation('Dashboard');

  return (
    <Box sx={{ width: '100%' }}>
      <Card style={CardContentStyle}>
        <div>
          <div style={CardContentTop}>
            <ListItemText
              primary={t2('WelcomeBack', [
                <span key={1} style={{ fontWeight: 'bold' }}>
                  {firstName}
                </span>,
              ])}
              secondary={t2('WelcomeMessage')}
              style={ListItemStyle}
            />
            <img src={ImagenDashboard} style={{ width: '40%' }} />
            <CardContent style={CardContentBack} />
          </div>
        </div>
      </Card>
    </Box>
  );
}
